export default __webpack_public_path__ + "static/media/form-handler.2eb61657.png";